export enum DividerOrientation {
	Horizontal = 'horizontal',
	Vertical = 'vertical',
}

export interface DividerProps {
	className?: string;
	orientation?: DividerOrientation;
}
